import { portalScreenContext } from '../../app/telemetry/portalTelemetry';
import { usePortalScreen } from '../../app/telemetry/usePortalTelemetry';
import _ from 'lodash';
import { VolunteeringTypeEnum } from '../../app/models/volunteering/common/volunteeringTypeEnum';
import VolunteeringForm from '../../app/models/volunteering/VolunteeringForm';

export default function MembershipVolunteeringForm() {
  usePortalScreen(portalScreenContext('MembershipVolunteeringForm'), undefined, true);

  return (
    <VolunteeringForm type={VolunteeringTypeEnum.MEMBER} />
  );
};
